var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { getIntersectionObserverConstructor } from "sb-resp-lib";
// THIS FILE IS IGNORED FROM COVERAGE REPORT
/*
    The switch between IntersectionObserver and the FakeIntersectionObserver
    is impossible to test due to lack of support on behalf of NodeJS.

    This API is not applicable on the serverside however this allows us
    to do good tests for the FakeIntersectionObserver.
*/
var defaultsOptions = {
    // root: null,
    rootMargin: "0px",
    threshold: .01
};
var Renderer = /** @class */ (function () {
    function Renderer(props) {
        var _OBS = getIntersectionObserverConstructor();
        this.observer = new _OBS(this.updateOnIdle.bind(this), __assign({}, defaultsOptions, props));
        this.isVisible = this.observer["faked"] || false;
    }
    Renderer.prototype.registerDom = function (element) {
        this.observer.observe(element);
    };
    Renderer.prototype.unRegisterDom = function (element) {
        this.observer.unobserve(element);
    };
    Renderer.prototype.updateOnIdle = function (entries) {
        var _this = this;
        window.cancelAnimationFrame(this.idleCallbackID);
        this.idleCallbackID = window.requestAnimationFrame(function () {
            _this.updateVisibility(entries);
        });
    };
    Renderer.prototype.updateVisibility = function (entries) {
        this.isVisible = entries[0].isIntersecting;
    };
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Renderer.prototype, "isVisible", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], Renderer.prototype, "updateVisibility", null);
    return Renderer;
}());
export { Renderer };
//# sourceMappingURL=Renderer.js.map